<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      id="consumabletype20211203"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
      @tree-load="treeLoad"
      v-if="resetFlag"
    >
      <template slot-scope="scope" slot="menu">
        <el-button type="text" size="small" icon="el-icon-plus" @click="openAddSonType(scope.row)"
          >新增子项
        </el-button>
      </template>
      <template slot="projectSearch" slot-scope="scope">
        <el-select
          v-if="projectFlag"
          v-model="query.project"
          placeholder="请选择项目名称"
          style="width: 100%"
          @change="(value) => projectChange(value)"
        >
          <el-option v-for="item in projectList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </template>

      <!-- <template slot="menuLeft">
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   plain
                   v-if="permission.consumabletype_delete"
                   @click="handleDelete">删 除
        </el-button>
      </template>-->
    </avue-crud>
    <hr-dialog
      title="新增子项"
      :visible.sync="addSonFlag"
      :modal-append-to-body="false"
      width="60%"
      :close-on-click-modal="false"
      @close="closeAddSonDialog"
      append-to-body
    >
    <template v-slot:body>
      <avue-form
        ref="sonForm"
        v-model="obj"
        :option="option1"
        label-width="100px"
        margin-top="0"
        @submit="sonSave"
      >
      <template slot-scope="scope" slot="menuForm">
          <el-button @click="avueExit">
            <i class="el-icon-circle-close"></i>
            取 消</el-button>
      </template>

      </avue-form>
      </template>
    </hr-dialog>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/crmedical/consumable/consumabletype';
import { mapGetters } from 'vuex';
import { getProjectList } from '@/api/crmedical/project/project';
import { treeChildren } from '@/api/crmedical/consumable/consumabletype';
import { async } from 'q';

var inputNumber = (rule, value, callback) => {
  var regNumber = /^\+?[1-9][0-9]*$/;
  if (!regNumber.test(value)) {
    callback(new Error('请输入大于 0 的整数！'));
  } else {
    callback();
  }
};

export default {
  data() {
    return {
      searchFlag: true,
      todoListLength: 10000000000000000,
      resetFlag: true,
      projectFlag: true,
      addSonFlag: false,
      obj: {},
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        // height: 'auto',
        // calcHeight: 'auto',
        dialogWidth: '65%',
        //  dialogHeight:432,
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        selection: false,
        defaultExpandAll: false,
        lazy: true,
        rowKey: 'id',
        tree: true,
        menuWidth: 300,
        columnBtn: true,
        searchMenuSpan: 12,
        dialogClickModal: false,
        column: [
          {
            label: '项目名称',
            prop: 'project',
            hide: true,
            editDisabled: true,
            rules: [
              {
                required: true,
                message: '请选择项目名称',
                trigger: 'blur',
              },
            ],
            search: true,
            searchslot: true,
            display: false,
            span: 12,
          },
          {
            label: '项目名称',
            prop: 'projectId',
            hide: true,
            editDisabled: true,
            rules: [
              {
                required: true,
                message: '请选择项目名称',
                trigger: 'change',
              },
            ],
            type: 'select',
            dicUrl: 'api/v4ward/project/getProjectList',
            props: {
              label: 'name',
              value: 'id',
            },
          },
          {
            label: '上级类型',
            prop: 'parentName',
            disabled: true,
            hide: true,
            value: '顶级节点',
            type: 'input',
          },

          {
            label: '类型名称',
            prop: 'name',
            rules: [
              {
                required: true,
                message: '请输入类型名称',
                trigger: 'change',
              },
            ],
            maxlength: 15,
            showWordLimit: true,
            overHidden: true,
            viewDisplay: true,
            search: true,
          },
          {
            label: '排序',
            prop: 'indexNo',
            rules: [
              {
                required: true,
                message: '请输入排序',
                trigger: 'change',
              },
              {
                validator: inputNumber,
                trigger: 'blur',
              },
            ],
            maxlength: 8,
            showWordLimit: true,
          },
        ],
      },
      option1: {
        emptyBtn: false,
        submitText: '保存',
        submitIcon: 'el-icon-circle-plus-outline',
        menuPosition: 'right',
        column: [
          {
            label: '项目',
            prop: 'projectName',
            type: 'input',
            disabled: true,
          },
          {
            label: '上级类型',
            prop: 'parentName',
            disabled: true,
            hide: true,
            value: '顶级节点',
            type: 'input',
          },
          {
            label: '类型名称',
            prop: 'name',
            rules: [
              {
                required: true,
                message: '请输入设备类型',
                trigger: 'change',
              },
            ],
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
          },
          {
            label: '排序',
            prop: 'indexNo',
            rules: [
              {
                required: true,
                message: '请输入排序',
                trigger: 'change',
              },
              {
                validator: inputNumber,
                trigger: 'blur',
              },
            ],
            maxlength: 8,
            showWordLimit: true,
          },
        ],
      },
      data: [],
      tree: {},
      treeNode: {},
      resolve: {},
      projectList: [],
      parentNode: {},
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.consumabletype_add, false),
        viewBtn: this.vaildData(this.permission.consumabletype_view, false),
        delBtn: this.vaildData(this.permission.consumabletype_delete, false),
        editBtn: this.vaildData(this.permission.consumabletype_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.option.height = this.bodyHeight - 398 + 55;
    resetFlag = true;
  },
  mounted() {
    console.log(this.option.height);
    console.log('this.$refs.crud.$children[0]', this.$refs.crud.$children[0].$el.offsetHeight);
    console.log('this.$refs.crud.$children[1]', this.$refs.crud.$children[1].$el.offsetHeight);
    console.log('this.$refs.crud.$children[3]', this.$refs.crud.$children[3].$el.offsetHeight);

    let height2 = this.$refs.crud.$children[1].$el.offsetHeight;
    let height3 = this.$refs.crud.$children[3].$el.offsetHeight;

    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.crud.$children[1].$children[3].$el.addEventListener('click', () => {
          // console.log(this.option.height,this.bodyHeight);
          this.searchFlag = !this.searchFlag;
          let height1 = this.$refs.crud.$children[0].$el.offsetHeight;
          if (this.todoListLength === 0) {
            if (this.option.height == this.bodyHeight - 398 + 55 + (78 - 46)) {
              this.option.height = this.bodyHeight - 398 + 55 + height1 - 1 + (78 - 46);
            } else {
              this.option.height = this.bodyHeight - 398 + 55 + (78 - 46);
            }
          } else {
            if (this.option.height == this.bodyHeight - 398 + 55) {
              this.option.height = this.bodyHeight - 398 + 55 + height1 - 1;
              console.log(height1, height2, height3);
            } else {
              this.option.height = this.bodyHeight - 398 + 55;
            }
          }
          this.$refs.crud.getTableHeight();
        });
      });
    });
  },
  methods: {
    avueExit(){
      this.addSonFlag = false
    },
    projectChange(value) {
      // this.projectFlag = false;
      this.query.projectId = value;
      this.query.project = value;
      this.query = Object.assign({}, this.query, {
        projectId: value,
        project: value,
      });
      // setTimeout(() => {
      //   this.projectFlag = true;
      // }, 10)
    },
    closeAddSonDialog() {
      this.addSonFlag = false;
      this.$refs.sonForm.resetForm();
    },
    openAddSonType(row) {
      console.log(row);
      this.obj.parentName = row.name;
      this.obj.parentId = row.id;
      this.obj.projectId = row.projectId;
      this.obj.projectName = row.projectName;
      this.parentNode = row;
      console.log(this.$refs.crud);
      this.addSonFlag = true;
      // this.$refs.crud.value.projectId = row.projectId;
      // row.parentId = row.id;
      // this.$refs.crud.rowAdd();
      // this.onLoad();

      // this.$refs.crud.value.projectId = row.id;
      // this.$refs.crud.option.column.filter(item => {
      //   console.log(item.prop);
      //   if (item.prop === "projectId") {
      //     item.value = row.id+'';
      //     // item.addDisabled = true;
      //   }
      // });
      // this.$refs.crud.rowAdd();
    },
    treeLoad(tree, treeNode, resolve) {
      this.tree = tree;
      this.treeNode = treeNode;
      // this.resolve = resolve;
      treeChildren({ parentId: tree.id }).then((data) => {
        resolve(data.data);
      });
    },
    rowSave(row, done, loading) {
      console.log('rowSave====>', row);
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    sonSave(row, done) {
      this.resetFlag = false;
      add(row).then(
        () => {
          this.addSonFlag = false;
          this.$message.success('操作成功!');
          this.$refs.sonForm.resetForm();
          setTimeout(() => {
            this.resetFlag = true;
          }, 50);

          done();
        },
        (error) => {
          done();
          console.log(error);
          this.resetFlag = true;
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      this.resetFlag = false;
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          setTimeout(() => {
            this.resetFlag = true;
          });
          done();
        },
        (error) => {
          this.resetFlag = true;
          loading();
        }
      );
    },
    rowDel(row, index, done) {
      console.log('这是row', row);
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          // this.resetFlag = false;
          return remove({ ids: row.id });
        })
        .then(
          async () => {
            // this.onLoad();
            this.$message.success('操作成功!');
            if (row.parentId == '0') {
              await this.onLoad(this.page);
            }
            done(row);
            console.log('8888888');
          },
          (error) => {
            // this.onLoad();
          }
        );
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
          if (!data.parentName) {
            this.form.parentName = '顶级节点';
          }
        });
      }
      done();
    },

    searchReset() {
      this.query.name = '';
      this.onLoad();
    },
    searchChange(params, done) {
      //this.query = params;
      this.query.name = params.name;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      if (this.query.projectId) {
        getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
          ({ data }) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();

            this.todoListLength = data.records.length;
            console.log('this.todoListLength', this.todoListLength);
            console.log('data.records.length', data.records.length);
            if (this.searchFlag) {
              if (data.records.length === 0) {
                this.option.height = this.bodyHeight - 398 + (78 - 46) + 55;
              } else {
                this.option.height = this.bodyHeight - 398 + 55;
              }
              this.$refs.crud.getTableHeight();
            }
          }
        );
      } else {
        getProjectList().then((data) => {
          this.projectList = data.data;
          if (this.projectList.length > 0) {
            this.query.projectId = this.projectList[0].id;
            this.query.project = this.projectList[0].name;
            getList(
              Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)
            ).then(({ data }) => {
              this.todoListLength = data.records.length;
              // console.log('this.todoListLength', this.todoListLength);
              // console.log('data.records.length', data.records.length);
              if (this.searchFlag) {
                if (data.records.length === 0) {
                  this.option.height = this.bodyHeight - 398 + (78 - 46) + 55;
                } else {
                  this.option.height = this.bodyHeight - 398 + 55;
                }
                this.$refs.crud.getTableHeight();
              }

              this.page.total = data.total;
              this.data = data.records;
              this.loading = false;
              this.selectionClear();
            });
          }
        });
      }
    },
  },
};
</script>

<style>
#consumabletype20211203 .avue-form__menu--center {
  padding-left: 430px !important;
}
::v-deep .avue-form__menu--center {
  text-align: right;
}
::v-deep .avue-crud__search .el-form-item--small.el-form-item {
  width: 100%;
}

</style>
